import { render } from "./MainStores.vue?vue&type=template&id=0da720e0&scoped=true"
import script from "./MainStores.vue?vue&type=script&lang=js"
export * from "./MainStores.vue?vue&type=script&lang=js"

import "./MainStores.vue?vue&type=style&index=0&id=0da720e0&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da720e0"]])

export default __exports__